import React from "react";
//import ReactGA from "react-ga";
import styled from "@emotion/styled/macro";

import DialogPortal from "../common/DialogPortal";

import hexDefault from "../res/img_menu_default.svg";
import hexActive from "../res/img_menu_active.svg";

import homeIcon from "../res/i_home.svg";
import collectionIcon from "../res/i_collection.svg";
import signInIcon from "../res/i_signin_light.svg";
//import signOutIcon from "../res/i_signout.svg";
import helpIcon from "../res/SmallHelpIcon.svg";
//import ApiService from "../ApiService";
import { withRouter, RouteComponentProps } from "react-router-dom";

const Root = styled("div")`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px 20px;
`;

const List = styled("ul")`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Item = styled<"li", { icon: string }>("li")`
  color: #fff;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  position: relative;

  &:before {
    content: "";
    display: block;
    width: 70px;
    height: 70px;
    background: url(${({ icon }) => icon}) no-repeat center center transparent;
    background-size: 20px;
    position: absolute;
    right: 0;
  }

  &:after {
    content: "";
    display: block;
    width: 70px;
    height: 70px;
    margin-left: 12px;
    background: url(${hexDefault}) no-repeat center center transparent;
  }

  &:active:after {
    background-image: url(${hexActive});
  }

  &:nth-of-type(2) {
    margin-right: 35px;
  }

  &:nth-of-type(4) {
    margin-right: 35px;
  }
`;

const Links = styled("div")`
  display: flex;
  justify-content: space-between;

  > a {
    color: #dbdbdc;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
  }

  > label {
    color: #dbdbdc;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
  }
`;

const CopyRight = styled("label")`
  display: flex;
  justify-content: space-between;
  color: #dbdbdc;
  font-size: 10px;
  font-weight: 500;
`;

interface IProps {
  isSignedIn: boolean;
  onClose: () => void;
  showSignInDialog: () => void;
}

function Menu({
  isSignedIn,
  onClose,
  showSignInDialog,
  history
}: IProps & RouteComponentProps<{}>) {
  const signIn = () => {
    onClose();
    showSignInDialog();
  };

  //const navigator: any = window.navigator;
  //const { protocol, host } = window.location;

  /*const signOut = async (e: React.MouseEvent) => {
    e.stopPropagation();
    ReactGA.event({
      category: "navigation",
      action: "sign out"
    });
    await ApiService.logOut();
    onClose();
  };*/

  const goToMyCollection = (e: React.MouseEvent) => {
    e.stopPropagation();
    //Bypassing original login
    //if (isSignedIn) {
      onClose();
      history.push("/collection");
    //} else {
     // signIn();
    //}
  };

  const goHome = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
    history.push("/" + window.location.search);
  };

  const getHelp = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
    window.open("https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FHelpDocument.pdf?alt=media&token=1ba1aabf-b7fc-49fc-a506-a16fbada0142", "_blank");
  };

  return (
    <DialogPortal onClose={onClose}>
      <Root
        onMouseDown={e => {
          e.stopPropagation();
        }}
        onMouseUp={e => {
          e.stopPropagation();
        }}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <nav>
          <List>
            <Item icon={homeIcon} onClick={goHome}>
              Home
            </Item>
            <Item icon={collectionIcon} onClick={goToMyCollection}>
              My Collection
            </Item>
            <Item icon={helpIcon} onClick={getHelp}>
                Help
            </Item>
            {isSignedIn ? (
              <Item icon={signInIcon} onClick={signIn}>
                Sign In
              </Item>
            ) : (
              {/*<Item icon={signInIcon} onClick={signOut}>
                Sign Out
            </Item>*/}
            )}
          </List>
        </nav>
        <CopyRight>© 2020 MLB Advanced Media, L.P. Major League Baseball trademarks and copyrights are used with permission of Major League Baseball. Visit MLB.com.</CopyRight>
        <Links>
          <a
            href="https://www.mlb.com/official-information/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.mlb.com/official-information/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          </Links>
      </Root>
    </DialogPortal>
  );
}

export default withRouter(Menu);
